<template>
  <div class="cmsdetail">
    <div class="wx_warn">
      <p class="wx_left">
        请您及时付款，以便订单尽快处理！订单号
        <span>{{ order_code }}</span>
      </p>
      <p class="wx_right">
        应付金额
        <span style="color:#ff6401; font-weight:bold; font-size:16px;">{{ price/100 }}</span>元
      </p>
    </div>
    <div class="wx_con">
      <div class="wx_con_top">
        <p class="wx_p">微信支付</p>
        <div class="top_mid">
          <p class="mid_p">二维码有效时长为2小时，请尽快支付</p>
          <img :src="pic_url" alt srcset />

          <div class="mid_bottom" style="margin-left: 40px;">
            <img src="https://www.meijiexia.cn/statics/cashier/wx_1.gif" />
            <p>
              请使用微信扫一扫
              <br />扫描二维码支付
            </p>
          </div>
        </div>
        <img class="wx_img" src="https://www.meijiexia.cn/statics/cashier/wx_2.gif" />
      </div>
      <!-- <p class="p_bottom">
        <a :href="link_url">< 选择其他方式支付</a>
      </p> -->
      <input type="hidden" id="payid" value="DF202011270940423475" />
    </div>
  </div>
</template>
<script>
export default {
  name: "WeixinPay",
  data() {
    return {
      //   breadData: [{ name: "首页",link:"/" },{ name: "萌星商城",link:"/goodslist" }], //面包屑的内容
      checked: false,
      pay_visible: false,
      loading: false,
      pay_loading: false,
      password: "",
      password2: "",
      multipleSelection: [],
      formData: {
        needLoadingIndicator: true,
        address_id: 0,
        goods_items: [],
        notes: {},
        coupon_used: {}
      },
      pay_price: 0,
      order_list: [],
      warnings: [],
      loginShow: false,
      goods_items: [],
      pay_type: 3,
      balance: {},
      orderIds: [],

      selectedPayType: "balance",
      havePayPassword: false,
      price: 0,
      types: [],
      list: [],
      pic_url: "",
      order_code: "",
      out_trade_no: "",
      link_url: "",
      timer:null
    };
  },
  mounted() {
    let that = this;
    this.getOrderPayType();

    this.timer = setInterval(function() {
      that.getOrderStatus();
    }, 1000);
  },
  methods: {
    getOrderStatus() {
      let that = this;
      let orderIds = JSON.parse(localStorage.getItem("orderIds"));
      
      this.$api.get(
        "/api/order/orderDetail",
        { id: orderIds[0] },
        res => {
          if (res.data.pay_status == 2) {
            that.$message.success("支付成功!");
            let timerOut = setTimeout(function() {
              window.location.href = that.url + "/subinfo?id=" + orderIds[0];
            }, 500);
          }
        },
        res => {}
      );
    },

    getOrderPayType() {
      let that = this;
      that.order_code = localStorage.getItem("order_code");
      let orderIds = JSON.parse(localStorage.getItem("orderIds"));
      let params = {
        ids: orderIds,
        scene:'goods'
      };
      this.$api.post("/api/order/getOrderPayTypes", params, res => {
        that.price = res.data.pay.price;
        that.types = res.data.pay.types;
        that.list = res.data.list;
        that.selectedPayType = res.data.selectedPayType;
        that.havePayPassword = res.data.havePayPassword;
        that.getOrderPay();
      });
    },

    getWeixinPay(out_trade_no) {
      let that = this;
      let order_title = localStorage.getItem("order_title");
      let order_code = that.out_trade_no;
      let form = {
        price: that.price / 100,
        order_code: out_trade_no,
        order_name: order_title
      };
      this.$api.post("/api/order/weixinPay", form, res => {
        that.pic_url = res.data;
      });
    },
    getOrderPay() {
      let that = this;
      let params = {
        orders: that.list,
        type: "native", 
      };
      this.$api.post("/api/order/orderpay", params, r2 => {
        console.log(r2);
        that.out_trade_no = r2.data.data.out_trade_no;
        that.getWeixinPay(r2.data.data.out_trade_no);
      });
    }
  },
  beforeDestroy(){
    clearInterval(this.timer)
    this.timer=null
  },
  components: {}
};
</script>
<style lang="scss" scoped>
.wx_top {
  width: 100%;
  height: 35x;
  line-height: 35px;
  background: #f7f7f7;
  border-bottom: 1px solid #eeeeee;
}
.wx_top .wx_top_con {
  width: 1000px;
  margin: 0 auto;
  height: 35px;
  line-height: 35px;
  background: #f7f7f7;
  border-bottom: 1px solid #eeeeee;
}
.wx_top .wx_top_con ul {
  float: right;
  color: #666;
}
.wx_top .wx_top_con ul li {
  float: left;
  padding: 0 10px;
}
.wx_top .wx_top_con ul li.wx_x {
  width: 1px;
  height: 15px;
  background: #dee5ee;
  float: left;
  padding: 0px;
  margin-top: 10px;
}
.wx_top .wx_top_con ul li a {
  padding: 0 5px;
  color: #666;
}
.wx_top .wx_top_con ul li a:hover {
  color: #ff6401;
}
.wx_nav {
  width: 100%;
  height: 100px;
  background: #fff;
}
.wx_nav .wx_nav_con {
  width: 1000px;
  height: 100px;
  background: #fff;
  margin: 0 auto;
  line-height: 100px;
}
.wx_nav .wx_nav_con img {
  margin-top: 15px;
  float: left;
}
.wx_nav .wx_nav_con p {
  padding-left: 20px;
  font-size: 20px;
  font-weight: bold;
  float: left;
  color: #222222;
}
.wx_warn {
  width: 1000px;
  height: 80px;
  line-height: 80px;
  margin: 0 auto;
}
.wx_warn p.wx_left {
  float: left;
}
.wx_warn p.wx_right {
  float: right;
}
.wx_con {
  width: 1000px;
  height: 600px;
  margin: 0px auto;
  background: #fff;
  box-shadow: #999 0px 0px 10px;
  -moz-box-shadow: #999 0px 0px 10px;
  -webkit-box-shadow: #999 0px 0px 10px;
}
.wx_con .wx_con_top {
  width: 1000px;
  height: 500px;
}
.wx_con .wx_con_top p.wx_p {
  width: 200px;
  line-height: 50px;
  float: left;
  font-size: 18px;
  text-align: center;
  color: #666666;
}
.wx_con .wx_con_top .top_mid {
  width: 400px;
  float: left;
  text-align: center;
}
.wx_con .wx_con_top .top_mid p.mid_p {
  color: #ff6401;
  line-height: 60px;
  text-align: left;
  margin-left: 42px;
}
.wx_con .wx_con_top .top_mid img {
  width: 296px;
  height: 297px;
  border: 1px solid #ccc;
  padding: 10px;
}
.wx_con .wx_con_top .top_mid .mid_bottom {
  width: 220px;
  height: 80px;
  background: #ff6401;
  margin: 10px 0px;
  padding: 0 50px;
}
.wx_con .wx_con_top .top_mid .mid_bottom img {
  float: left;
  width: 45px;
  height: 45px;
  border: none;
  margin-top: 6px;
}
.wx_con .wx_con_top .top_mid .mid_bottom p {
  float: left;
  line-height: 20px;
  color: #fff;
  font-size: 15px;
  margin-top: 15px;
}
.wx_con .wx_img {
  float: left;
  margin: 50px 0 0 10px;
}
.wx_con .p_bottom a {
  padding: 0 50px;
  line-height: 80px;
  color: #2ea7e7;
  font-weight: bold;
  font-size: 15px;
}
.wx_foot {
  width: 1000px;
  height: 60px;
  margin: 40px auto;
  border-top: 1px solid #ccc;
  text-align: center;
}
.wx_foot p {
  line-height: 50px;
  color: #999;
}
.wx_foot .wx_foot_img {
  width: 550px;
  margin: 0 auto;
}
.wx_foot .wx_foot_img img {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// WeixinPay.vue?40fa96b3